<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">AllPort</h3>
    </div>
</div>
<app-camera *ngIf="testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div *ngIf="texts" #instructions class="m-b-30"></div>
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <h3><b>AUTODESCRIPCIÓN Y METAS</b></h3>
                        <form [formGroup]="userForm" class="m-t-40 form-material">
                            <div class="form-group m-b-40">
                                <label for="input1">Es una persona que se autodescribe como:</label>
                                <input formControlName="1" type="text" class="form-control" id="input1">
                                <span class="bar"></span>
                            </div>
                            <div class="form-group m-b-40">
                                <label for="input2">Siente gran aprecio por:</label>
                                <input formControlName="2" type="text" class="form-control" id="input2">
                                <span class="bar"></span>
                            </div>
                            <div class="form-group m-b-40">
                                <label for="input3">Lo que mas le disgusta:</label>
                                <input formControlName="3" type="text" class="form-control" id="input3">
                                <span class="bar"></span>
                            </div>
                            <div class="form-group m-b-40">
                                <label for="input4">Tiene como metas personales y profesionales:</label>
                                <input formControlName="4" type="text" class="form-control" id="input4">
                                <span class="bar"></span>
                            </div>
        
                            
                        </form>
                    </div>

                </div>
                
                <div class="col-12">
                    
                    <button class="btn btn-info waves-effect btn-rounded mx-2 mx-2" (click)="reload()">Cancelar</button>
                    <button type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>
           
                </div>
                
                        
                            <!-- sample modal content -->
                            <div id="myModal"  data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                                <div class="modal-dialog modal-lg">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="modal-title" id="myModalLabel">AllPort</h4>
         
                                        </div>
                                        <div *ngIf="selectedQuestion.part && selectedQuestion.part=='1'" class="modal-body">
                                            <h4>Seleccione una opción</h4>

                                            <p>{{selectedQuestion.title}}</p>
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <p class="text-center text-primary"><strong>A - {{selectedQuestion.opcA.text}}</strong></p>
                                                        <div class="row justify-content-center m-b-40">
                                                            <div class="col-md-6">
                                                                <button type="button" class="btn btn-block btn-info selected" (click)="setSelected('0')" >Totalmente de acuerdo con A</button>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <button type="button" class="btn btn-block btn-info selected" (click)="setSelected('1')" >Ligera preferencia por A</button>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <p class="text-center text-primary"><strong>B - {{selectedQuestion.opcB.text}}</strong></p>
                                                        <div class="row justify-content-center">
                                                            <div class="col-md-6">
                                                                <button type="button" class="btn btn-block btn-info selected" (click)="setSelected('2')" >Totalmente de acuerdo con B</button>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <button type="button" class="btn btn-block btn-info selected" (click)="setSelected('3')" >Ligera preferencia por B</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row justify-content-center">
                                                    
                                                        <button type="button" class="btn btn-info waves-effect selected" (click)="setSelected('4')" >Me es imposible decidirme</button>
                                                        <button type="button" [disabled]="!actualSelect" class="btn btn-secondary waves-effect" (click)="nextQuestion(actualSelect)" >Siguiente</button>
                                                    
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div *ngIf="selectedQuestion.part=='2'" class="modal-body">
                                            <h4>Seleccióne sus opciónes de la más a la menos preferente</h4>

                                            <p>{{selectedQuestion.title}}</p>
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <a style="font-size: 14px; color:white; white-space: normal;" type="button" class="btn btn-block btn-lg btn-info" (click)="select('0')" >{{selectedQuestion.opcA.text}}</a>

                                                    </div>
                                                    <div class="col-md-2">
                                                        <span *ngIf="orderAnswers[0]==1" class="badge badge-success ml-auto">Más</span>
                                                        <span *ngIf="orderAnswers[0]==2" class="badge badge-success ml-auto">{{orderAnswers[0]}}</span>
                                                        <span *ngIf="orderAnswers[0]==3" class="badge badge-success ml-auto">{{orderAnswers[0]}}</span>
                                                        <span *ngIf="orderAnswers[0]==4" class="badge badge-success ml-auto">Menos</span>
                                                        <br>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <a style="font-size: 14px; color:white; white-space: normal;" type="button" class="btn btn-block btn-lg btn-info" (click)="select('1')" >{{selectedQuestion.opcB.text}}</a>

                                                    </div>
                                                    <div class="col-md-2">
                                                        <span *ngIf="orderAnswers[1]==1" class="badge badge-success ml-auto">Más</span>
                                                        <span *ngIf="orderAnswers[1]==2" class="badge badge-success ml-auto">{{orderAnswers[1]}}</span>
                                                        <span *ngIf="orderAnswers[1]==3" class="badge badge-success ml-auto">{{orderAnswers[1]}}</span>
                                                        <span *ngIf="orderAnswers[1]==4" class="badge badge-success ml-auto">Menos</span>
                                                        <br>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <a style="font-size: 14px; color:white; white-space: normal;" type="button" class="btn btn-block btn-lg btn-info" (click)="select('2')" >{{selectedQuestion.opcC.text}}</a>

                                                    </div>
                                                    <div class="col-md-2">

                                                        <span *ngIf="orderAnswers[2]==1" class="badge badge-success ml-auto">Más</span>
                                                        <span *ngIf="orderAnswers[2]==2" class="badge badge-success ml-auto">{{orderAnswers[2]}}</span>
                                                        <span *ngIf="orderAnswers[2]==3" class="badge badge-success ml-auto">{{orderAnswers[2]}}</span>
                                                        <span *ngIf="orderAnswers[2]==4" class="badge badge-success ml-auto">Menos</span>
                                                        <br>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col m-b-15">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <a style="font-size: 14px; color:white; white-space: normal;" type="button" class="btn btn-block btn-lg btn-info" (click)="select('3')" >{{selectedQuestion.opcD.text}}</a>

                                                    </div>
                                                    <div class="col-md-2">

                                                        <span *ngIf="orderAnswers[3]==1" class="badge badge-success ml-auto">Más</span>
                                                        <span *ngIf="orderAnswers[3]==2" class="badge badge-success ml-auto">{{orderAnswers[3]}}</span>
                                                        <span *ngIf="orderAnswers[3]==3" class="badge badge-success ml-auto">{{orderAnswers[3]}}</span>
                                                        <span *ngIf="orderAnswers[3]==4" class="badge badge-success ml-auto">Menos</span>
                                                        <br>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <button type="button" class="btn btn-info waves-effect" (click)="select('4')" >Me es imposible decidirme</button>
                                                </div>

                                            </div>
                                            <div *ngIf="selectedQuestion.part=='2'" class="row justify-content-center">
               
                                                    <button type="button" class="btn btn-danger waves-effect" (click)="clear()">Borrar respuestas</button>
                                                    
                                                    <button type="button" class="btn btn-info waves-effect" (click)="select('5')" >Siguiente</button>

                                            </div>
                                            
                                        </div>

                                    </div>
                                    <!-- /.modal-content -->
                                </div>
                                <!-- /.modal-dialog -->
                            </div>
                            <!-- /.modal -->
                      
               
            </div>
        </div>
    </div>
</div>